import Link from "next/link"
import { useCopy } from "@/lib/contexts/appContext"
import classNames from "classnames"
import styles from "./menus/menu.module.css"

export default function Organization() {
  const { footer } = useCopy()
  const { organization } = footer

  if (!organization) {
    return null
  }

  return (
    <>
      <h3 className={styles.heading}>
        {organization?.heading ?? "Naturskyddsföreningen på din ort"}
      </h3>
      <ul
        className={classNames([styles.menu, "tertiary"])}
        data-location="tertiary-footer-menu">
        {organization?.counties &&
          organization.counties.map((item) => {
            const uri = organization.uri
              ? organization.uri + "?lan=" + item.slug
              : item.url

            if (!uri) {
              return null
            }

            return (
              <li key={item.slug} role="menuitem">
                <Link href={uri} prefetch={false}>
                  {item.name}
                </Link>
              </li>
            )
          })}
      </ul>
    </>
  )
}
